<div class="wrapper">
    <div class="costing">
        <wbo-stock-costing-type-single-select-edit-control
            class="costing-type" [class.customisable]="allowCustomCost"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="costingType"
            [allowCustomCost]="allowCustomCost"></wbo-stock-costing-type-single-select-edit-control>
        <wbo-currency-edit-control *ngIf="allowCustomCost && costingType === StockCostingType.CUSTOM_COST"
                                   class="costing-custom"
                                   [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="customCost"></wbo-currency-edit-control>
    </div>
    <wbo-outlet-single-select-edit-control
        class="outlets"
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="outletId"
        [clearSelectionOptionLabel]="'wbo.stock.option.costing-outlet.all'"
        [placeholder]="'wbo.stock.option.costing-outlet.all'"></wbo-outlet-single-select-edit-control>
</div>
